import React, { Component } from 'react'
import { Input, Form, Modal, DatePicker, Popconfirm, Button, Checkbox, Switch } from 'antd'
import moment from 'moment'
import Attachments from './Attachments'
import Notes from './Notes'
import FollowUps from '../FollowUps'
import styled from 'styled-components'
import InputMask from 'react-input-mask'

const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`

const FormItem = Form.Item

class AddEditForm extends Component {
  handleCreateEmployee = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }
      this.props.handleAddEmployee(values)
      form.resetFields()
    })
  }

  handleCancel = () => {
    this.props.handleToggleAddEditForm()
    const form = this.props.form
    form.resetFields()
  }

  handleEditEmployee = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.termination_date = values.termination_date
        ? moment(values.termination_date).format('YYYY/MM/DD HH:mm:ss')
        : null

      values.hire_date = values.hire_date
        ? moment(values.hire_date).format('YYYY/MM/DD HH:mm:ss')
        : null

      // checklist items prepare
      values.other1_text = values.other1 ? values.other1_text : ''
      values.other2_text = values.other2 ? values.other2_text : ''
      values.other3_text = values.other3 ? values.other3_text : ''
      values.other4_text = values.other4 ? values.other4_text : ''
      values.other5_text = values.other5 ? values.other5_text : ''

      this.props.handleEditEmployee(values)
      form.resetFields()
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { modalVisible, currentEmployee } = this.props
    return (
      <Modal
        visible={modalVisible}
        title="Employee"
        okText={currentEmployee ? 'Save Changes' : 'Add Employee'}
        onCancel={this.handleCancel}
        onOk={currentEmployee ? this.handleEditEmployee : this.handleCreateEmployee}
        width={'95%'}
        maskClosable={false}
      >
        <Form layout="vertical">
          {currentEmployee && (
            <FormItem label="Set Status">
              <div className="row">
                <div className="col-md-12">
                  <Switch
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                    defaultChecked={currentEmployee.status === 'inactive' ? false : true}
                    onChange={this.props.setStatus}
                  />
                </div>
              </div>
            </FormItem>
          )}
          <div className="row">
            <div className="col-md-6">
              <FormItem label="First Name">
                {getFieldDecorator('first_name', {
                  rules: [
                    {
                      required: true,
                      message: 'First Name cannot be blank.'
                    }
                  ],
                  initialValue: currentEmployee ? currentEmployee.first_name : ''
                })(<Input placeholder="Enter first name..." />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Last Name">
                {getFieldDecorator('last_name', {
                  initialValue: currentEmployee ? currentEmployee.last_name : ''
                })(<Input placeholder="Enter last name..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="E-mail">
                    {getFieldDecorator('email', {
                      rules: [
                        {
                          type: 'email',
                          message: 'You must use a valid email.'
                        }
                      ],
                      initialValue: currentEmployee ? currentEmployee.email : ''
                    })(<Input placeholder="Enter the e-mail..." />)}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Phone Number">
                    {getFieldDecorator('phone_number', {
                      initialValue: currentEmployee ? currentEmployee.phone_number : ''
                    })(
                      <InputMask
                        className="ant-input"
                        mask="(999) 999-9999 ext:9999"
                        maskChar="_"
                      />
                    )}
                  </FormItem>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Hire Date">
                    {getFieldDecorator('hire_date', {
                      rules: [
                        {
                          required: true,
                          message: 'Hire Date cannot be blank.'
                        }
                      ],

                      initialValue:
                        currentEmployee && currentEmployee.hire_date
                          ? moment(currentEmployee.hire_date)
                          : null
                    })(<StyledDatePicker />)}
                  </FormItem>
                </div>
                {currentEmployee && (
                  <div className="col-md-6">
                    <FormItem label="Termination Date">
                      {getFieldDecorator('termination_date', {
                        initialValue:
                          currentEmployee && currentEmployee.termination_date
                            ? moment(currentEmployee.termination_date)
                            : null
                      })(<StyledDatePicker />)}
                    </FormItem>
                  </div>
                )}
              </div>
            </div>
          </div>
          {currentEmployee && (
            <div>
              <div className="row">
                <div className="col-md-12">
                  <h5>Checklist</h5>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  {getFieldDecorator('new_employee_checklist', {
                    initialValue: currentEmployee.new_employee_checklist,
                    valuePropName: 'checked'
                  })(<Checkbox>new_employee_checklist</Checkbox>)}
                </div>
                <div className="col-md-4">
                  {getFieldDecorator('identification', {
                    initialValue: currentEmployee.identification,
                    valuePropName: 'checked'
                  })(<Checkbox>identification</Checkbox>)}
                </div>
                <div className="col-md-4">
                  {getFieldDecorator('contact_information', {
                    initialValue: currentEmployee.contact_information,
                    valuePropName: 'checked'
                  })(<Checkbox>contact_information</Checkbox>)}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  {getFieldDecorator('handbook_acknowledgement', {
                    initialValue: currentEmployee.handbook_acknowledgement,
                    valuePropName: 'checked'
                  })(<Checkbox>handbook_acknowledgement</Checkbox>)}
                </div>
                <div className="col-md-4">
                  {getFieldDecorator('employee_setup_form', {
                    initialValue: currentEmployee.employee_setup_form,
                    valuePropName: 'checked'
                  })(<Checkbox>employee_setup_form</Checkbox>)}
                </div>
                <div className="col-md-4">
                  {getFieldDecorator('i9', {
                    initialValue: currentEmployee.i9,
                    valuePropName: 'checked'
                  })(<Checkbox>i9</Checkbox>)}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  {getFieldDecorator('safety_bag_acknowledgement', {
                    initialValue: currentEmployee.safety_bag_acknowledgement,
                    valuePropName: 'checked'
                  })(<Checkbox>safety_bag_acknowledgement</Checkbox>)}
                </div>
                <div className="col-md-4">
                  {getFieldDecorator('w4', {
                    initialValue: currentEmployee.w4,
                    valuePropName: 'checked'
                  })(<Checkbox>w4</Checkbox>)}
                </div>
                <div className="col-md-4">
                  {getFieldDecorator('direct_deposit', {
                    initialValue: currentEmployee.direct_deposit,
                    valuePropName: 'checked'
                  })(<Checkbox>direct_deposit</Checkbox>)}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">&nbsp;</div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <h6>Others</h6>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  {getFieldDecorator('other1', {
                    initialValue: currentEmployee.other1,
                    valuePropName: 'checked'
                  })(<Checkbox>other1</Checkbox>)}
                </div>
                <div className="col-md-4">
                  <FormItem>
                    {getFieldDecorator('other1_text', {
                      initialValue: currentEmployee ? currentEmployee.other1_text : ''
                    })(<Input placeholder="Enter the other description..." />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  {getFieldDecorator('other2', {
                    initialValue: currentEmployee.other2,
                    valuePropName: 'checked'
                  })(<Checkbox>other2</Checkbox>)}
                </div>
                <div className="col-md-4">
                  <FormItem>
                    {getFieldDecorator('other2_text', {
                      initialValue: currentEmployee ? currentEmployee.other2_text : ''
                    })(<Input placeholder="Enter the other description..." />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  {getFieldDecorator('other3', {
                    initialValue: currentEmployee.other3,
                    valuePropName: 'checked'
                  })(<Checkbox>other3</Checkbox>)}
                </div>
                <div className="col-md-4">
                  <FormItem>
                    {getFieldDecorator('other3_text', {
                      initialValue: currentEmployee ? currentEmployee.other3_text : ''
                    })(<Input placeholder="Enter the other description..." />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  {getFieldDecorator('other4', {
                    initialValue: currentEmployee.other4,
                    valuePropName: 'checked'
                  })(<Checkbox>other4</Checkbox>)}
                </div>
                <div className="col-md-4">
                  <FormItem>
                    {getFieldDecorator('other4_text', {
                      initialValue: currentEmployee ? currentEmployee.other4_text : ''
                    })(<Input placeholder="Enter the other description..." />)}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2">
                  {getFieldDecorator('other5', {
                    initialValue: currentEmployee.other5,
                    valuePropName: 'checked'
                  })(<Checkbox>other5</Checkbox>)}
                </div>
                <div className="col-md-4">
                  <FormItem>
                    {getFieldDecorator('other5_text', {
                      initialValue: currentEmployee ? currentEmployee.other5_text : ''
                    })(<Input placeholder="Enter the other description..." />)}
                  </FormItem>
                </div>
              </div>
            </div>
          )}
        </Form>
        {currentEmployee && (
          <div className="row">
            <div className="col-md-6">
              <Notes
                notes={this.props.notes}
                handleToggleNoteEditArea={this.props.handleToggleNoteEditArea}
                noteAddEditContainer={this.props.noteAddEditContainer}
                userId={this.props.userId}
                createNote={this.props.createNote}
                currentNote={this.props.currentNote}
                handleRowNoteClick={this.props.handleRowNoteClick}
                updateNote={this.props.updateNote}
                deleteNote={this.props.deleteNote}
              />
            </div>
            <div className="col-md-6">
              <FollowUps
                followUps={this.props.followUps}
                handleToggleFollowUpEditArea={this.props.handleToggleFollowUpEditArea}
                followUpAddEditContainer={this.props.followUpAddEditContainer}
                userId={this.props.userId}
                createFollowUp={this.props.createFollowUp}
                currentFollowUp={this.props.currentFollowUp}
                handleRowFollowUpClick={this.props.handleRowFollowUpClick}
                updateFollowUp={this.props.updateFollowUp}
                deleteFollowUp={this.props.deleteFollowUp}
                autocompleteUsers={this.props.autocompleteUsers}
                autocompleteRoles={this.props.autocompleteRoles}
                followUpAssignToType={this.props.followUpAssignToType}
                changeAssignedToType={this.props.changeAssignedToType}
                handleResetFollowUpForm={this.props.handleResetFollowUpForm}
              />
            </div>
          </div>
        )}
        {currentEmployee && (
          <Attachments
            currentId={this.props.currentId}
            userId={this.props.userId}
            attachmentList={this.props.attachmentList}
            loadingAttachments={this.props.loadingAttachments}
            uploadingAttachment={this.props.uploadingAttachment}
            uploadAttachment={this.props.uploadAttachment}
            updateAttachmentDescription={this.props.updateAttachmentDescription}
            deleteAttachment={this.props.deleteAttachment}
            deletingAttachment={this.props.deletingAttachment}
          />
        )}
        {currentEmployee && (
          <Popconfirm
            title="Are you sure you want to delete this record?"
            onConfirm={this.props.handleDeleteEmployee}
            onCancel={this.cancelDelete}
            okText="Yes"
            cancelText="No"
          >
            {currentEmployee && <Button type="danger" icon="delete" />}
          </Popconfirm>
        )}
      </Modal>
    )
  }
}

export default Form.create()(AddEditForm)



// WEBPACK FOOTER //
// ./src/components/employees/AddEditForm.js